import ISerializable from '../../../../lib/ISerializable';

export default abstract class PreviewElement implements ISerializable {
  constructor(protected element?) {}

  public serialize(): string {
    return JSON.stringify({ element: this.element });
  }

  public deserialize(data: string): void {
    const parsedData = JSON.parse(data);
    this.element = parsedData.element;
  }

  /**
   * Return the information which will be saved in the api session route.
   * This information about the element is used to create website template in the backend.
   */
  abstract injectSessionData(page): void;

  /**
   * Return the element data needed to be injected in the preview when the preview page is opened.
   * This is data only needed for the preview and not for the api session route.
   */
  public getElementDataForPreview() {
    return this.element;
  }

  public getUniqueId() {
    return this.element?.uniqueId;
  }
}
